import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "w-full max-w-[calc(100%-98px)] md:max-w-[456px] flex items-center justify-between" }
const _hoisted_4 = { class: "text-base font-medium leading-[22px] text-black capitalize" }
const _hoisted_5 = { class: "text-[12px] font-medium text-textMedium" }
const _hoisted_6 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-center" }, "Prosimy o cierpliwość, sprawdzanie terminów może potrwać nawet do 10 sekund", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "mx-auto hours w-full max-w-[calc(100%-98px)] md:max-w-[456px] flex items-start justify-between" }
const _hoisted_10 = ["onClick"]

import { ref, computed, watch } from 'vue';
import { format, addDays, isBefore, startOfDay, parseISO } from 'date-fns';
import PrevDaysButton from './components/PrevDaysButton.vue';
import NextDaysButton from './components/NextDaysButton.vue';
import { formatDate } from '../../../../../helpers/formatDate.js';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import { pl } from 'date-fns/locale';
import { useField } from 'vee-validate';
import { useNumberOfVisibleDays } from '../Calendar/hooks/useNumberOfVisibleDays.js';
import 'vue3-perfect-scrollbar/style.css';


export default {
  __name: 'Calendar',
  props: {
    schedule: {
        type: Object,
        required: true,
    },
    status: {
        type: String,
        required: true,
    },
    toggleModal: {
        type: Function,
    },
},
  setup(__props) {

const props = __props;


const { value: selectedCallDateValue } = useField('selectedConsultationDate');
const { numberOfVisibleDays } = useNumberOfVisibleDays();

const visibleStartDate = ref(
    selectedCallDateValue.value?.date ? parseISO(selectedCallDateValue.value.date) : new Date(),
);

const maxSlots = computed(() => {
    return Math.max(...Object.values(props.schedule).map((slots) => Object.keys(slots).length));
});

const getDays = (startDate, numberOfDays) => {
    const days = [];
    let currentDate = new Date(startDate);
    for (let i = 0; i < numberOfDays; i++) {
        days.push({
            date: format(currentDate, 'yyyy-MM-dd'),
            weekday: format(currentDate, 'EEE', { locale: pl }),
        });
        currentDate = addDays(currentDate, 1);
    }
    return days;
};

const currentWeekDays = computed(() => getDays(visibleStartDate.value, numberOfVisibleDays.value));

const setPreviousDays = () => {
    visibleStartDate.value = addDays(visibleStartDate.value, -numberOfVisibleDays.value);
};

const setNextDays = () => {
    visibleStartDate.value = addDays(visibleStartDate.value, numberOfVisibleDays.value);
};

const isPreviousDaysDisabled = computed(() => {
    const today = startOfDay(new Date());
    return isBefore(visibleStartDate.value, addDays(today, 1));
});

const getClass = (date, hour) => {
    const slotStatus = props.schedule[date] && props.schedule[date][hour];
    if (!slotStatus) return 'not-available';

    if (isBefore(date, startOfDay(new Date()))) {
        return 'not-available';
    }

    return {
        available: slotStatus === 'available',
        reserved: slotStatus === 'reserved',
        'not-available': slotStatus === '-',
        selected: isSelected(date, hour),
    };
};

const isSelected = (date, hour) => {
    return (
        selectedCallDateValue.value &&
        selectedCallDateValue.value.date === date &&
        selectedCallDateValue.value.hour === hour
    );
};

const selectTimeSlot = (date, hour) => {
    if (props.schedule[date] && props.schedule[date][hour] === 'available') {
        selectedCallDateValue.value = { date, hour };
        props.toggleModal();
    }
};

const generateSlotsForDay = (date) => {
    const slots = props.schedule[date] ? Object.keys(props.schedule[date]) : [];
    while (slots.length < maxSlots.value) {
        slots.push('-');
    }
    return slots.map((time) => ({ time }));
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PrevDaysButton, {
        isDisabled: _unref(isPreviousDaysDisabled),
        onOnPreviousDaysClick: setPreviousDays
      }, null, 8, ["isDisabled"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentWeekDays), (day) => {
          return (_openBlock(), _createElementBlock("div", {
            key: day.date,
            class: "day max-w-[72px] w-full"
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(day.weekday), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatDate)(day.date)), 1)
          ]))
        }), 128))
      ]),
      _createVNode(NextDaysButton, { onOnNextDaysClick: setNextDays })
    ]),
    (__props.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    (__props.status === 'success')
      ? (_openBlock(), _createBlock(_unref(PerfectScrollbar), { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentWeekDays), (day) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: day.date,
                  class: "day-slots max-w-[72px] w-full"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(generateSlotsForDay(day.date), (slot) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: slot.time,
                      class: _normalizeClass(['time-slot  w-full', getClass(day.date, slot.time)]),
                      onClick: $event => (selectTimeSlot(day.date, slot.time))
                    }, _toDisplayString(slot.time), 11, _hoisted_10))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}